import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './dashboard.component';
import { SharedModule } from '../shared/shared.module';
import { FormsModule } from '@angular/forms'; 
import { NgxPaginationModule } from 'ngx-pagination';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { DashboardService } from "./services/dashboard.service";

@NgModule({
  declarations: [DashboardComponent],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    NgxPaginationModule,
    TranslateModule,
    RouterModule
  ],
  exports: [
    DashboardComponent
  ],
  providers: [DashboardService]
})
export class DashboardModule { }
